import(/* webpackMode: "eager" */ "/app/src/app/(frontend)/error.tsx");
